const Icons = {
	arrowLeft: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14.59 18L16 16.59L11.42 12L16 7.41L14.59 6L8.58997 12L14.59 18Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	arrowRight: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.99997 6L8.58997 7.41L13.17 12L8.58997 16.59L9.99997 18L16 12L9.99997 6Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	arrowDown: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			transform="rotate(90)"
		>
			<path
				d="M9.99997 6L8.58997 7.41L13.17 12L8.58997 16.59L9.99997 18L16 12L9.99997 6Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	arrowUp: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			transform="rotate(-90)"
		>
			<path
				d="M9.99997 6L8.58997 7.41L13.17 12L8.58997 16.59L9.99997 18L16 12L9.99997 6Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	add: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	bell: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16ZM16 17H8V11C8 8.52 9.51 6.5 12 6.5C14.49 6.5 16 8.52 16 11V17Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	book: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21 5C19.89 4.65 18.67 4.5 17.5 4.5C15.55 4.5 13.45 4.9 12 6C10.55 4.9 8.45 4.5 6.5 4.5C4.55 4.5 2.45 4.9 1 6V20.65C1 20.9 1.25 21.15 1.5 21.15C1.6 21.15 1.65 21.1 1.75 21.1C3.1 20.45 5.05 20 6.5 20C8.45 20 10.55 20.4 12 21.5C13.35 20.65 15.8 20 17.5 20C19.15 20 20.85 20.3 22.25 21.05C22.35 21.1 22.4 21.1 22.5 21.1C22.75 21.1 23 20.85 23 20.6V6C22.4 5.55 21.75 5.25 21 5ZM21 18.5C19.9 18.15 18.7 18 17.5 18C15.8 18 13.35 18.65 12 19.5V8C13.35 7.15 15.8 6.5 17.5 6.5C18.7 6.5 19.9 6.65 21 7V18.5Z"
				fill="#1E5FA7"
			/>
			<path
				d="M17.5 10.5C18.38 10.5 19.23 10.59 20 10.76V9.24C19.21 9.09 18.36 9 17.5 9C15.8 9 14.26 9.29 13 9.83V11.49C14.13 10.85 15.7 10.5 17.5 10.5Z"
				fill="#1E5FA7"
			/>
			<path
				d="M13 12.49V14.15C14.13 13.51 15.7 13.16 17.5 13.16C18.38 13.16 19.23 13.25 20 13.42V11.9C19.21 11.75 18.36 11.66 17.5 11.66C15.8 11.66 14.26 11.96 13 12.49Z"
				fill="#1E5FA7"
			/>
			<path
				d="M17.5 14.33C15.8 14.33 14.26 14.62 13 15.16V16.82C14.13 16.18 15.7 15.83 17.5 15.83C18.38 15.83 19.23 15.92 20 16.09V14.57C19.21 14.41 18.36 14.33 17.5 14.33Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	bookmark: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M17 3H7C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.9 18.1 3 17 3ZM17 18L12 15.82L7 18V5H17V18Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	calculate: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM13.03 7.06L14.09 6L15.5 7.41L16.91 6L17.97 7.06L16.56 8.47L17.97 9.88L16.91 10.94L15.5 9.54L14.09 10.95L13.03 9.89L14.44 8.48L13.03 7.06ZM6.25 7.72H11.25V9.22H6.25V7.72ZM11.5 16H9.5V18H8V16H6V14.5H8V12.5H9.5V14.5H11.5V16ZM18 17.25H13V15.75H18V17.25ZM18 14.75H13V13.25H18V14.75Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	calendar: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H19C20.1 22 21 21.1 21 20V6C21 4.9 20.1 4 19 4ZM19 20H5V10H19V20ZM19 8H5V6H19V8ZM12 13H17V18H12V13Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	calendarChecked: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V9H19V19ZM5 7V5H19V7H5ZM10.56 17.46L16.49 11.53L15.43 10.47L10.56 15.34L8.45 13.23L7.39 14.29L10.56 17.46Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	calendarEdit: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5 10H19V12H21V6C21 4.9 20.1 4 19 4H18V2H16V4H8V2H6V4H5C3.89 4 3.01 4.9 3.01 6L3 20C3 21.1 3.89 22 5 22H12V20H5V10ZM5 6H19V8H5V6ZM22.84 16.28L22.13 16.99L20.01 14.87L20.72 14.16C21.11 13.77 21.74 13.77 22.13 14.16L22.84 14.87C23.23 15.26 23.23 15.89 22.84 16.28ZM19.3 15.58L21.42 17.7L16.12 23H14V20.88L19.3 15.58Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	camera: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M17 10.5V7C17 6.45 16.55 6 16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	cancel: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM17 15.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59L15.59 7L17 8.41L13.41 12L17 15.59Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	cart: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.55 13C17.3 13 17.96 12.59 18.3 11.97L21.88 5.48C22.25 4.82 21.77 4 21.01 4H6.21L5.27 2H2V4H4L7.6 11.59L6.25 14.03C5.52 15.37 6.48 17 8 17H20V15H8L9.1 13H16.55ZM7.16 6H19.31L16.55 11H9.53L7.16 6ZM8 18C6.9 18 6.01 18.9 6.01 20C6.01 21.1 6.9 22 8 22C9.1 22 10 21.1 10 20C10 18.9 9.1 18 8 18ZM18 18C16.9 18 16.01 18.9 16.01 20C16.01 21.1 16.9 22 18 22C19.1 22 20 21.1 20 20C20 18.9 19.1 18 18 18Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	checked: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	check: (
		<svg
			width="14"
			height="11"
			viewBox="0 0 14 11"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4.75078 8.15001L1.60078 5.00001L0.550781 6.05001L4.75078 10.25L13.7508 1.25001L12.7008 0.200012L4.75078 8.15001Z"
				fill="#3B82F6"
			/>
		</svg>
	),
	copy: (
		<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" fill="#1E5FA7">
			<g id="Layer_100" data-name="Layer 100">
				<path d="M44.84,10.5H24.9a5,5,0,0,0-5,5V42.8a5,5,0,0,0,5,5H44.84a5,5,0,0,0,5-5V15.46A5,5,0,0,0,44.84,10.5Zm2,32.3a2,2,0,0,1-2,2H24.9a2,2,0,0,1-2-2V15.46a2,2,0,0,1,2-2H44.84a2,2,0,0,1,2,2Z" />
				<path d="M39.07,50.5H19.18a2,2,0,0,1-2-2V21.23a1.5,1.5,0,0,0-3,0V48.51a5,5,0,0,0,5,5H39.07A1.5,1.5,0,0,0,39.07,50.5Z" />
			</g>
		</svg>
	),
	creditCard: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M20 4H4C2.89 4 2.01 4.89 2.01 6L2 18C2 19.11 2.89 20 4 20H20C21.11 20 22 19.11 22 18V6C22 4.89 21.11 4 20 4ZM20 18H4V12H20V18ZM20 8H4V6H20V8Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	desktop: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M20 18C21.1 18 22 17.1 22 16V6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V16C2 17.1 2.9 18 4 18H0V20H24V18H20ZM4 6H20V16H4V6Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	discount: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.41 11.58L12.41 2.58C12.05 2.22 11.55 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.55 2.22 12.05 2.59 12.42L11.59 21.42C11.95 21.78 12.45 22 13 22C13.55 22 14.05 21.78 14.41 21.41L21.41 14.41C21.78 14.05 22 13.55 22 13C22 12.45 21.77 11.94 21.41 11.58ZM13 20.01L4 11V4H11V3.99L20 12.99L13 20.01Z"
				fill="#1E5FA7"
			/>
			<path
				d="M6.5 8C7.32843 8 8 7.32843 8 6.5C8 5.67157 7.32843 5 6.5 5C5.67157 5 5 5.67157 5 6.5C5 7.32843 5.67157 8 6.5 8Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	download: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M19 9H15V3H9V9H5L12 16L19 9ZM5 18V20H19V18H5Z" fill="#1E5FA7" />
		</svg>
	),
	edit: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M2.99875 17.2513V21.0013H6.74875L17.8088 9.94128L14.0588 6.19128L2.99875 17.2513ZM20.7087 7.04128C21.0987 6.65128 21.0987 6.02128 20.7087 5.63128L18.3688 3.29128C17.9788 2.90128 17.3488 2.90128 16.9587 3.29128L15.1288 5.12128L18.8787 8.87128L20.7087 7.04128Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	options: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	phoneCrossed: (
		<svg
			width="25"
			height="24"
			viewBox="0 0 25 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_157_6073)">
				<path
					d="M17.8406 14.5401L16.4106 13.1101C16.9706 12.3801 17.4606 11.6101 17.8806 10.7901L15.6806 8.59006C15.4006 8.31006 15.3206 7.92006 15.4306 7.57006C15.8006 6.45006 16.0006 5.25006 16.0006 4.00006C16.0006 3.45006 16.4506 3.00006 17.0006 3.00006H20.5006C21.0506 3.00006 21.5006 3.45006 21.5006 4.00006C21.5006 7.98006 20.1306 11.6401 17.8406 14.5401ZM15.0206 17.3501C12.1306 19.6401 8.47062 21.0001 4.50063 21.0001C3.95063 21.0001 3.50063 20.5501 3.50063 20.0001V16.5101C3.50063 15.9601 3.95063 15.5101 4.50063 15.5101C5.74063 15.5101 6.95063 15.3101 8.07063 14.9401C8.42063 14.8201 8.82063 14.9101 9.09063 15.1801L11.2906 17.3801C12.1006 16.9601 12.8706 16.4801 13.5906 15.9201L1.89062 4.22006L3.31062 2.81006L21.6906 21.2001L20.2806 22.6101L15.0206 17.3501Z"
					fill="#DC2626"
				/>
			</g>
			<defs>
				<clipPath id="clip0_157_6073">
					<rect
						width="24"
						height="24"
						fill="white"
						transform="translate(0.5)"
					/>
				</clipPath>
			</defs>
		</svg>
	),
	eye: (
		<svg
			width="25"
			height="25"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_950_1136)">
				<path
					d="M12.5 6.82454C16.29 6.82454 19.67 8.95454 21.32 12.3245C19.67 15.6945 16.29 17.8245 12.5 17.8245C8.71 17.8245 5.33 15.6945 3.68 12.3245C5.33 8.95454 8.71 6.82454 12.5 6.82454ZM12.5 4.82454C7.5 4.82454 3.23 7.93454 1.5 12.3245C3.23 16.7145 7.5 19.8245 12.5 19.8245C17.5 19.8245 21.77 16.7145 23.5 12.3245C21.77 7.93454 17.5 4.82454 12.5 4.82454ZM12.5 9.82454C13.88 9.82454 15 10.9445 15 12.3245C15 13.7045 13.88 14.8245 12.5 14.8245C11.12 14.8245 10 13.7045 10 12.3245C10 10.9445 11.12 9.82454 12.5 9.82454ZM12.5 7.82454C10.02 7.82454 8 9.84454 8 12.3245C8 14.8045 10.02 16.8245 12.5 16.8245C14.98 16.8245 17 14.8045 17 12.3245C17 9.84454 14.98 7.82454 12.5 7.82454Z"
					fill="#60A5FA"
				/>
			</g>
			<defs>
				<clipPath id="clip0_950_1136">
					<rect
						width="24"
						height="24"
						fill="white"
						transform="translate(0.5 0.824539)"
					/>
				</clipPath>
			</defs>
		</svg>
	),
	facebook: (
		<svg
			width="12"
			height="23"
			viewBox="0 0 12 23"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M11.1219 12.3783L11.7332 8.39574H7.91094V5.81135C7.91094 4.7218 8.44488 3.65976 10.1568 3.65976H11.8944V0.269056C11.8944 0.269056 10.3175 0 8.80987 0C5.66211 0 3.60458 1.90746 3.60458 5.36048V8.39574H0.105591V12.3783H3.60458V22.0058H7.91094V12.3783H11.1219Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	filter: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4.255 5.61C6.275 8.2 10.005 13 10.005 13V19C10.005 19.55 10.455 20 11.005 20H13.005C13.555 20 14.005 19.55 14.005 19V13C14.005 13 17.725 8.2 19.745 5.61C20.255 4.95 19.785 4 18.955 4H5.045C4.215 4 3.745 4.95 4.255 5.61Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	resize: (
		<svg
			width="25"
			height="24"
			viewBox="0 0 25 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M21.5 11V3H13.5L16.79 6.29L6.79 16.29L3.5 13V21H11.5L8.21 17.71L18.21 7.71L21.5 11Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	globe: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM18.92 8H15.97C15.65 6.75 15.19 5.55 14.59 4.44C16.43 5.07 17.96 6.35 18.92 8ZM12 4.04C12.83 5.24 13.48 6.57 13.91 8H10.09C10.52 6.57 11.17 5.24 12 4.04ZM4.26 14C4.1 13.36 4 12.69 4 12C4 11.31 4.1 10.64 4.26 10H7.64C7.56 10.66 7.5 11.32 7.5 12C7.5 12.68 7.56 13.34 7.64 14H4.26ZM5.08 16H8.03C8.35 17.25 8.81 18.45 9.41 19.56C7.57 18.93 6.04 17.66 5.08 16ZM8.03 8H5.08C6.04 6.34 7.57 5.07 9.41 4.44C8.81 5.55 8.35 6.75 8.03 8ZM12 19.96C11.17 18.76 10.52 17.43 10.09 16H13.91C13.48 17.43 12.83 18.76 12 19.96ZM14.34 14H9.66C9.57 13.34 9.5 12.68 9.5 12C9.5 11.32 9.57 10.65 9.66 10H14.34C14.43 10.65 14.5 11.32 14.5 12C14.5 12.68 14.43 13.34 14.34 14ZM14.59 19.56C15.19 18.45 15.65 17.25 15.97 16H18.92C17.96 17.65 16.43 18.93 14.59 19.56ZM16.36 14C16.44 13.34 16.5 12.68 16.5 12C16.5 11.32 16.44 10.66 16.36 10H19.74C19.9 10.64 20 11.31 20 12C20 12.69 19.9 13.36 19.74 14H16.36Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	gmail: (
		<svg
			width="28"
			height="20"
			viewBox="0 0 28 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
		>
			<rect x="0.666748" width="26.6667" height="20" fill="url(#pattern0)" />
			<defs>
				<pattern
					id="pattern0"
					patternContentUnits="objectBoundingBox"
					width="1"
					height="1"
				>
					<use
						xlinkHref="#image0_55_345"
						transform="scale(0.00416667 0.00555556)"
					/>
				</pattern>
				<image
					id="image0_55_345"
					width="240"
					height="180"
					xlinkHref="data:image/png;base64,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"
				/>
			</defs>
		</svg>
	),
	halfStar: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M22 9.24L14.81 8.62L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27L18.18 21L16.55 13.97L22 9.24ZM12 15.4V6.1L13.71 10.14L18.09 10.52L14.77 13.4L15.77 17.68L12 15.4Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	hamburger: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	info: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V11H13V17ZM13 9H11V7H13V9Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	linkedIn: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M19 0H5C2.239 0 0 2.239 0 5V19C0 21.761 2.239 24 5 24H19C21.762 24 24 21.761 24 19V5C24 2.239 21.762 0 19 0ZM8 19H5V8H8V19ZM6.5 6.732C5.534 6.732 4.75 5.942 4.75 4.968C4.75 3.994 5.534 3.204 6.5 3.204C7.466 3.204 8.25 3.994 8.25 4.968C8.25 5.942 7.467 6.732 6.5 6.732ZM20 19H17V13.396C17 10.028 13 10.283 13 13.396V19H10V8H13V9.765C14.396 7.179 20 6.988 20 12.241V19Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	grid: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4 8H8V4H4V8ZM10 20H14V16H10V20ZM4 20H8V16H4V20ZM4 14H8V10H4V14ZM10 14H14V10H10V14ZM16 4V8H20V4H16ZM10 8H14V4H10V8ZM16 14H20V10H16V14ZM16 20H20V16H16V20Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	lock: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6H9C9 4.34 10.34 3 12 3C13.66 3 15 4.34 15 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM18 20H6V10H18V20ZM12 17C13.1 17 14 16.1 14 15C14 13.9 13.1 13 12 13C10.9 13 10 13.9 10 15C10 16.1 10.9 17 12 17Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	logout: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M17 8L15.59 9.41L17.17 11H9V13H17.17L15.59 14.58L17 16L21 12L17 8ZM5 5H12V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H12V19H5V5Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	mail: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	minus: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M19 13L5 13V11L19 11V13Z" fill="#1E5FA7" />
		</svg>
	),
	smartphone: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15.5 1H7.5C6.12 1 5 2.12 5 3.5V20.5C5 21.88 6.12 23 7.5 23H15.5C16.88 23 18 21.88 18 20.5V3.5C18 2.12 16.88 1 15.5 1ZM11.5 22C10.67 22 10 21.33 10 20.5C10 19.67 10.67 19 11.5 19C12.33 19 13 19.67 13 20.5C13 21.33 12.33 22 11.5 22ZM16 18H7V4H16V18Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	moon: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.37 5.51C9.19 6.15 9.1 6.82 9.1 7.5C9.1 11.58 12.42 14.9 16.5 14.9C17.18 14.9 17.85 14.81 18.49 14.63C17.45 17.19 14.93 19 12 19C8.14 19 5 15.86 5 12C5 9.07 6.81 6.55 9.37 5.51ZM12 3C7.03 3 3 7.03 3 12C3 16.97 7.03 21 12 21C16.97 21 21 16.97 21 12C21 11.54 20.96 11.08 20.9 10.64C19.92 12.01 18.32 12.9 16.5 12.9C13.52 12.9 11.1 10.48 11.1 7.5C11.1 5.69 11.99 4.08 13.36 3.1C12.92 3.04 12.46 3 12 3Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	phoneLocked: (
		<svg
			width="25"
			height="24"
			viewBox="0 0 25 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_157_6089)">
				<path
					d="M20.5 5V4C20.5 2.9 19.6 2 18.5 2C17.4 2 16.5 2.9 16.5 4V5H15.5V10H21.5V5H20.5ZM19.5 5H17.5V4C17.5 3.45 17.95 3 18.5 3C19.05 3 19.5 3.45 19.5 4V5Z"
					fill="#DC2626"
				/>
				<path
					d="M16.1314 14.4L13.6114 16.9C11.1114 15.47 9.04136 13.4 7.61136 10.9L10.1114 8.38C10.3414 8.14 10.4414 7.81 10.3814 7.48L9.63136 3.8C9.54136 3.34 9.13136 3 8.65136 3H4.50136C3.94136 3 3.47136 3.47 3.50136 4.03C3.67136 6.92 4.55136 9.63 5.93136 12C7.51136 14.73 9.78136 16.99 12.5014 18.57C14.8714 19.94 17.5814 20.83 20.4714 21C21.0314 21.03 21.5014 20.56 21.5014 20V15.85C21.5014 15.37 21.1614 14.96 20.7014 14.87L17.0314 14.14C16.7014 14.07 16.3614 14.17 16.1314 14.4Z"
					fill="#DC2626"
				/>
			</g>
			<defs>
				<clipPath id="clip0_157_6089">
					<rect
						width="24"
						height="24"
						fill="white"
						transform="translate(0.5)"
					/>
				</clipPath>
			</defs>
		</svg>
	),
	phone: (
		<svg
			width="19"
			height="19"
			viewBox="0 0 19 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M13.63 11.4L11.11 13.9C8.61 12.47 6.54 10.4 5.11 7.9L7.61 5.38C7.84 5.14 7.94 4.81 7.88 4.48L7.13 0.8C7.04 0.34 6.63 0 6.15 0H2C1.44 0 0.970003 0.47 1 1.03C1.17 3.92 2.05 6.63 3.43 9C5.01 11.73 7.28 13.99 10 15.57C12.37 16.94 15.08 17.83 17.97 18C18.53 18.03 19 17.56 19 17V12.85C19 12.37 18.66 11.96 18.2 11.87L14.53 11.14C14.2 11.07 13.86 11.17 13.63 11.4Z"
				fill="#1e5fa7"
			/>
		</svg>
	),
	plus: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="#1E5FA7" />
		</svg>
	),
	questionnaire: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M19 3H14.82C14.4 1.84 13.3 1 12 1C10.7 1 9.6 1.84 9.18 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM12 3C12.55 3 13 3.45 13 4C13 4.55 12.55 5 12 5C11.45 5 11 4.55 11 4C11 3.45 11.45 3 12 3ZM14 17H7V15H14V17ZM17 13H7V11H17V13ZM17 9H7V7H17V9Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	quote: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M6 17H9L11 13V7H5V13H8L6 17ZM14 17H17L19 13V7H13V13H16L14 17Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	search: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	diploma: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M20 2H4C2.89 2 2 2.89 2 4V15C2 16.11 2.89 17 4 17H8V22L12 20L16 22V17H20C21.11 17 22 16.11 22 15V4C22 2.89 21.11 2 20 2ZM20 15H4V13H20V15ZM20 10H4V4H20V10Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	calendarCrossed: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V9H19V19ZM5 7V5H19V7H5ZM8.23 16.41L9.29 17.47L11.73 15.03L14.17 17.47L15.23 16.41L12.79 13.97L15.23 11.53L14.17 10.47L11.73 12.91L9.29 10.47L8.23 11.53L10.67 13.97L8.23 16.41Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	phoneMissed: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g clipPath="url(#clip0_157_5989)">
				<path
					d="M6.5 5.5L12 11L19 4L18 3L12 9L7.5 4.5H11V3H5V9H6.5V5.5ZM23.71 16.67C20.66 13.78 16.54 12 12 12C7.46 12 3.34 13.78 0.29 16.67C0.11 16.85 0 17.1 0 17.38C0 17.66 0.11 17.91 0.29 18.09L2.77 20.57C2.95 20.75 3.2 20.86 3.48 20.86C3.75 20.86 4 20.75 4.18 20.58C4.97 19.84 5.87 19.22 6.84 18.73C7.17 18.57 7.4 18.23 7.4 17.83V14.73C8.85 14.25 10.4 14 12 14C13.6 14 15.15 14.25 16.6 14.72V17.82C16.6 18.21 16.83 18.56 17.16 18.72C18.14 19.21 19.03 19.84 19.83 20.57C20.01 20.75 20.26 20.85 20.53 20.85C20.81 20.85 21.06 20.74 21.24 20.56L23.72 18.08C23.9 17.9 24.01 17.65 24.01 17.37C24.01 17.09 23.89 16.85 23.71 16.67Z"
					fill="black"
				/>
			</g>
			<defs>
				<clipPath id="clip0_157_5989">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</svg>
	),
	morning: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<mask id="path-1-inside-1_1_389" fill="white">
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M22 17C22 11.4772 17.5228 7 12 7C6.47715 7 2 11.4772 2 17H22Z"
				/>
			</mask>
			<path
				d="M22 17V19H24V17H22ZM2 17H0V19H2V17ZM12 9C16.4183 9 20 12.5817 20 17H24C24 10.3726 18.6274 5 12 5V9ZM4 17C4 12.5817 7.58172 9 12 9V5C5.37258 5 0 10.3726 0 17H4ZM2 19H22V15H2V19Z"
				fill="#1E5FA7"
				mask="url(#path-1-inside-1_1_389)"
			/>
		</svg>
	),
	userCrossed: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M8.65001 5.82006C9.36001 4.72006 10.6 4.00006 12 4.00006C14.21 4.00006 16 5.79006 16 8.00006C16 9.40006 15.28 10.6401 14.18 11.3501L8.65001 5.82006ZM20 17.1701C19.98 16.0701 19.37 15.0601 18.39 14.5501C17.85 14.2701 17.26 14.0101 16.62 13.7901L20 17.1701ZM21.19 21.1901L2.81001 2.81006L1.39001 4.22006L10.28 13.1101C8.47001 13.3401 6.89001 13.9001 5.61001 14.5601C4.61001 15.0701 4.00001 16.1001 4.00001 17.2201V20.0001H17.17L19.78 22.6101L21.19 21.1901Z"
				fill="black"
			/>
		</svg>
	),
	star: (
		<svg
			width="37"
			height="36"
			viewBox="0 0 37 36"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="0.0488281"
				y="0.615234"
				width="36"
				height="35"
				rx="17.5"
				fill="#0D9488"
			/>
			<g clipPath="url(#clip0_95_840)">
				<path
					d="M18.0488 23.3852L24.2288 27.1152L22.5888 20.0852L28.0488 15.3552L20.8588 14.7452L18.0488 8.11523L15.2388 14.7452L8.04883 15.3552L13.5088 20.0852L11.8688 27.1152L18.0488 23.3852Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_95_840">
					<rect
						width="24"
						height="24"
						fill="white"
						transform="translate(6.04883 6.11523)"
					/>
				</clipPath>
			</defs>
		</svg>
	),
	statistics: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5 9.2H8V19H5V9.2ZM10.6 5H13.4V19H10.6V5ZM16.2 13H19V19H16.2V13Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	sun: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 9C13.65 9 15 10.35 15 12C15 13.65 13.65 15 12 15C10.35 15 9 13.65 9 12C9 10.35 10.35 9 12 9ZM12 7C9.24 7 7 9.24 7 12C7 14.76 9.24 17 12 17C14.76 17 17 14.76 17 12C17 9.24 14.76 7 12 7ZM2 13H4C4.55 13 5 12.55 5 12C5 11.45 4.55 11 4 11H2C1.45 11 1 11.45 1 12C1 12.55 1.45 13 2 13ZM20 13H22C22.55 13 23 12.55 23 12C23 11.45 22.55 11 22 11H20C19.45 11 19 11.45 19 12C19 12.55 19.45 13 20 13ZM11 2V4C11 4.55 11.45 5 12 5C12.55 5 13 4.55 13 4V2C13 1.45 12.55 1 12 1C11.45 1 11 1.45 11 2ZM11 20V22C11 22.55 11.45 23 12 23C12.55 23 13 22.55 13 22V20C13 19.45 12.55 19 12 19C11.45 19 11 19.45 11 20ZM5.99 4.58C5.6 4.19 4.96 4.19 4.58 4.58C4.19 4.97 4.19 5.61 4.58 5.99L5.64 7.05C6.03 7.44 6.67 7.44 7.05 7.05C7.43 6.66 7.44 6.02 7.05 5.64L5.99 4.58ZM18.36 16.95C17.97 16.56 17.33 16.56 16.95 16.95C16.56 17.34 16.56 17.98 16.95 18.36L18.01 19.42C18.4 19.81 19.04 19.81 19.42 19.42C19.81 19.03 19.81 18.39 19.42 18.01L18.36 16.95ZM19.42 5.99C19.81 5.6 19.81 4.96 19.42 4.58C19.03 4.19 18.39 4.19 18.01 4.58L16.95 5.64C16.56 6.03 16.56 6.67 16.95 7.05C17.34 7.43 17.98 7.44 18.36 7.05L19.42 5.99ZM7.05 18.36C7.44 17.97 7.44 17.33 7.05 16.95C6.66 16.56 6.02 16.56 5.64 16.95L4.58 18.01C4.19 18.4 4.19 19.04 4.58 19.42C4.97 19.8 5.61 19.81 5.99 19.42L7.05 18.36Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	paragaph: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M3 18H15V16H3V18ZM3 6V8H21V6H3ZM3 13H21V11H3V13Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	transactions: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M18 17H6V15H18V17ZM18 13H6V11H18V13ZM18 9H6V7H18V9ZM3 22L4.5 20.5L6 22L7.5 20.5L9 22L10.5 20.5L12 22L13.5 20.5L15 22L16.5 20.5L18 22L19.5 20.5L21 22V2L19.5 3.5L18 2L16.5 3.5L15 2L13.5 3.5L12 2L10.5 3.5L9 2L7.5 3.5L6 2L4.5 3.5L3 2V22Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	trash: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z"
				fill="#dc2626"
			/>
		</svg>
	),
	university: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 3L1 9L5 11.18V17.18L12 21L19 17.18V11.18L21 10.09V17H23V9L12 3ZM18.82 9L12 12.72L5.18 9L12 5.28L18.82 9ZM17 15.99L12 18.72L7 15.99V12.27L12 15L17 12.27V15.99Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	user: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	users: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9 13.75C6.66 13.75 2 14.92 2 17.25V19H16V17.25C16 14.92 11.34 13.75 9 13.75ZM4.34 17C5.18 16.42 7.21 15.75 9 15.75C10.79 15.75 12.82 16.42 13.66 17H4.34ZM9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM9 7C9.83 7 10.5 7.67 10.5 8.5C10.5 9.33 9.83 10 9 10C8.17 10 7.5 9.33 7.5 8.5C7.5 7.67 8.17 7 9 7ZM16.04 13.81C17.2 14.65 18 15.77 18 17.25V19H22V17.25C22 15.23 18.5 14.08 16.04 13.81ZM15 12C16.93 12 18.5 10.43 18.5 8.5C18.5 6.57 16.93 5 15 5C14.46 5 13.96 5.13 13.5 5.35C14.13 6.24 14.5 7.33 14.5 8.5C14.5 9.67 14.13 10.76 13.5 11.65C13.96 11.87 14.46 12 15 12Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	wallet: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M20.5 18V19C20.5 20.1 19.6 21 18.5 21H4.5C3.39 21 2.5 20.1 2.5 19V5C2.5 3.9 3.39 3 4.5 3H18.5C19.6 3 20.5 3.9 20.5 5V6H11.5C10.39 6 9.5 6.9 9.5 8V16C9.5 17.1 10.39 18 11.5 18H20.5ZM11.5 16H21.5V8H11.5V16ZM15.5 13.5C14.67 13.5 14 12.83 14 12C14 11.17 14.67 10.5 15.5 10.5C16.33 10.5 17 11.17 17 12C17 12.83 16.33 13.5 15.5 13.5Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	suitcase: (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M14 6V4H10V6H14ZM4 8V19H20V8H4ZM20 6C21.11 6 22 6.89 22 8V19C22 20.11 21.11 21 20 21H4C2.89 21 2 20.11 2 19L2.01 8C2.01 6.89 2.89 6 4 6H8V4C8 2.89 8.89 2 10 2H14C15.11 2 16 2.89 16 4V6H20Z"
				fill="#1E5FA7"
			/>
		</svg>
	),
	document: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			stroke-width="2"
			stroke="#1E5FA7"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M14 3v4a1 1 0 0 0 1 1h4" />
			<path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
			<path d="M9 17h6" />
			<path d="M9 13h6" />
		</svg>
	),
	uploadFile: (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			stroke-width="2"
			stroke="#1E5FA7"
			fill="none"
			stroke-linecap="round"
			stroke-linejoin="round"
		>
			<path stroke="none" d="M0 0h24v24H0z" fill="none" />
			<path d="M14 3v4a1 1 0 0 0 1 1h4" />
			<path d="M17 21h-10a2 2 0 0 1 -2 -2v-14a2 2 0 0 1 2 -2h7l5 5v11a2 2 0 0 1 -2 2z" />
			<path d="M12 11v6" />
			<path d="M9.5 13.5l2.5 -2.5l2.5 2.5" />
		</svg>
	),
} as const;

export default Icons;
